import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 320 320" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M176.78 63.29l136 136a23.89 23.89 0 010 33.89l-22.59 22.59a23.89 23.89 0 01-33.89 0l-96.47-96.27-96.41 96.33a23.89 23.89 0 01-33.89 0l-22.7-22.59a23.91 23.91 0 010-33.89l136-136a23.92 23.92 0 0134-.1z" /></svg>);